import { useCallback, useEffect } from 'react';
import { getDistance } from '@helpers/getDistance';
import { geoSliceSchema } from '../types/geoSchema';
import { actionsGeo } from '../slice/geoSlice';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { getLocation } from '../selectors/getLocation';
import { getAccess } from '../selectors/getAccess';
import { getError } from '../selectors/getError';

interface useCurrentLocationType extends geoSliceSchema {
  getDistance: (sh1: number, dl1: number, sh2: number, dl2: number) => number;
}

const TIMEOUT_LOADING_GEO = 5000;

export const useCurrentLocation = (options: PositionOptions = { timeout: TIMEOUT_LOADING_GEO, maximumAge: 0 }): useCurrentLocationType => {
  const dispatch = useAppDispatch();
  const location = useAppSelector(getLocation);
  const access = useAppSelector(getAccess);
  const error = useAppSelector(getError);

  const handleSuccess = useCallback(position => {
    const { latitude, longitude } = position.coords;
    dispatch(
      actionsGeo.initGeoData({
        location: { latitude, longitude },
        access: true,
        error: null,
      }),
    );
  }, []);

  const handleError = useCallback(error => {
    dispatch(
      actionsGeo.initGeoData({
        location: null,
        access: false,
        error: error?.message,
      }),
    );
    console.log(error);
  }, []);
  useEffect(() => {
    if (!location && !error && navigator && typeof navigator !== 'undefined') {
      navigator?.geolocation?.getCurrentPosition(handleSuccess, handleError, options);
    }
  }, []);

  return { location, error, access, getDistance };
};
